//https://imask.js.org/
import IMask from "imask";

window.addEventListener('load', function () {
    //Ajout d'un masque sur les champs de numéros de téléphone, SIRET, ...
    let inputMasquesElements = document.querySelectorAll('[data-mask]');

    if (inputMasquesElements != null && inputMasquesElements.length > 0) {
        inputMasquesElements.forEach(function (inputMasqueElement) {
            IMask(inputMasqueElement, {
                mask: inputMasqueElement.dataset.mask,
                lazy: inputMasqueElement.dataset['mask-visible'] === 'true'
            });
        });
    }
});